<template>
  <div id="app">
    <div v-if="!this.$route.meta.author" class="readuser" :class="{ 'has-tabbar': showTabbar }">
      <div :class="{ indexheader: $route.path == '/index' && isSticky }" class="header" v-if="this.$route.meta.top">
        <div class="typerea">
          <div>
            <img @click="jump('/index', '跳转首页')" src="./images/logo.png" alt="">
            <div class="tag">
              <div class="tags" @click="jump('/classify', '跳转分类')">
                <img src="./images/browse.svg" alt="">
                <span>{{ $t("index.oeuvre") }}</span>
              </div>
              <div class="tags" @click="jump('/rank', '跳转排行榜')">
                <img src="./images/rank.svg" alt="">
                <span>{{ $t("index.ranking") }}</span>
              </div>
              <div class="tags" @click="jump('/authorhome', '跳转作者页面')">
                <img src="./images/create.svg" alt="">
                <span>{{ $t("index.authorzone") }}</span>
              </div>
            </div>
          </div>
          <div>
            <div class="search">
              <SearchBox :light="$route.fullPath == '/index' && isSticky" />
            </div>
            <div v-if="!isLoggedIn" @click="jumplogin" class="loginbut">Sign in</div>
            <div v-else class="tou">
              <img :src="UserInfo.userPhoto" @click="jumpuser" alt="">
              <div v-if="this.$store?.state?.webSocketMsg != 0" v-show="showDot" class="dian"></div>
              <div class="userpopup">
                <div class="jiao"></div>
                <div class="usermess" @click="jumpuser">
                  <img :src="UserInfo.userPhoto" alt="">
                  <div>
                    <span>{{ UserInfo?.nickName }}</span>
                    <i>ID:{{ UserInfo?.id }}</i>
                  </div>
                </div>
                <div class="getmore">
                  <div class="money">
                    <span class="r"></span>{{ UserInfo?.accountBalance }}
                  </div>
                  <div @click="paypopupshow = true" class="button">GET MORE</div>
                </div>
                <div class="link">
                  <p @click="jumpuserinfo">Notification<em>{{ this.$store.state.webSocketMsg ? '' : '' }}</em></p>
                  <p @click="jumplibrary">My library</p>
                  <p @click="jumpuser(true)">Purchase record</p>
                </div>
                <div class="outlogin" @click="outlogin">Log out</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <router-view v-if="!$route.meta.huancun"></router-view>
      <keep-alive>
        <router-view v-if="$route.meta.huancun"></router-view>
      </keep-alive>
      <div class="bottom" v-if="this.$route.meta.buttom">
        <div class="tit">
          <img src="@/images/login-logo.svg" alt="">
          <div class="tag">
            <span>About us</span>
            <span @click="showContactUs">Contact us</span>
            <span>Help center</span>
            <span>Notice</span>
          </div>
        </div>
        <div class="con">
          <div class="apple" @click="jumpToAppStore">
            <img src="./images/apple.svg" alt="">
            <div class="store">
              <span>Download on the</span>
              <i>App Store</i>
            </div>
          </div>
          <img src="./images/Goodle-logo.svg" alt="">
        </div>
        <div class="bot">
          <div class="typerea">
            <span>Copyright @rosettanovel 2026</span>
            <span><i @click="jumppolicy(1)">Terms of Service</i>·<i @click="jumppolicy(2)">Privacy Policy</i>·<i
                @click="jumppolicy(3)">Cookie
                Policy</i></span>
          </div>
        </div>
      </div>

      <!-- 移动端底部 Tab 导航：仅在 5 个主页面 + 窄屏显示（CSS 控制） -->
      <nav class="mobile-tabbar" v-if="showTabbar">
        <a v-for="t in tabbarItems" :key="t.path" class="tab-item"
          :class="{ active: isTabActive(t.path) }" @click="goTab(t.path)">
          <span class="tab-ico" v-html="t.icon"></span>
          <span class="tab-label">{{ t.label }}</span>
        </a>
      </nav>
    </div>

    <!-- Contact Us Modal -->
    <div v-if="contactUsShow" class="contact-modal-overlay" @click="closeContactUs">
      <div class="contact-modal" @click.stop>
        <div class="contact-modal-header">
          <h3>Contact Us</h3>
          <span class="close-btn" @click="closeContactUs">&times;</span>
        </div>
        <div class="contact-modal-content">
          <div class="contact-section">
            <h4>General Contact & Support</h4>
            <p><strong>Email:</strong> <a href="mailto:contact@rosettanovel.com">contact@rosettanovel.com</a></p>
            <p>For general inquiries, technical support, user feedback, etc.</p>
          </div>
          <div class="contact-section">
            <h4>Career Opportunities</h4>
            <p><strong>Email:</strong> <a href="mailto:recruit@rosettanovel.com">recruit@rosettanovel.com</a></p>
            <p>For job-related inquiries, resume submissions, etc.</p>
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <paypopup v-if="paypopupshow" @paypopupguan="paypopupshow = false"></paypopup>
    </transition>
    <authorhome v-if="this.$route.meta.author"></authorhome>
  </div>
</template>

<script>
import authorhome from "@/views/AuthorCenter/home.vue"
import paypopup from "./paypopup.vue";
import SearchBox from "@/components/SearchBox.vue";
import { websocket } from "@/api"
import { ensureVisitor } from '@/utils/uuid_token';

export default {
  name: 'App',
  components: {
    authorhome,
    paypopup,
    SearchBox,
  },
  data() {
    return {
      languageValue: '',
      languageOptions: [],
      isSticky: true, // 控制粘性定位的布尔值
      notifications: [], // 存储消息通知的数组
      pollingInterval: null, // 轮询的定时器ID
      showDot: true, // 控制是否显示红点
      blinkInterval: null, // 定时器ID
      paypopupshow: false,
      contactUsShow: false, // 控制联系方式弹窗显示
      // 移动端底部 Tab：内联 currentColor 图标，选中态由 CSS 控制颜色
      tabbarItems: [
        { path: '/index', label: 'Home', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5"/><path d="M9.5 21v-6h5v6"/></svg>' },
        { path: '/classify', label: 'Browse', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>' },
        { path: '/rank', label: 'Rankings', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v5a5 5 0 0 1-10 0V4Z"/><path d="M7 5H4v2a3 3 0 0 0 3 3"/><path d="M17 5h3v2a3 3 0 0 1-3 3"/></svg>' },
        { path: '/library', label: 'Library', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4.5A1.5 1.5 0 0 1 5.5 3H19a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5.5A1.5 1.5 0 0 1 4 18.5v-14Z"/><path d="M4 17.5A1.5 1.5 0 0 1 5.5 16H20"/></svg>' },
        { path: '/user', label: 'Me', icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>' },
      ],
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    UserInfo() {
      return this.$store.state.userInfo
    },
    // 仅在 5 个主页面渲染底部 Tab（窄屏才显示，由 CSS 媒体查询控制）
    showTabbar() {
      return this.tabbarItems.some(t => t.path === this.$route.path)
    }
  },
  watch: {
    // 路由切换后按新页面的实际滚动位置重算顶栏状态。
    // 否则：在别的页面下滑 >1000px 把 isSticky 置 false 后，回到首页顶部时它仍为 false，
    // 导致首页顶栏丢掉 indexheader（透明）类、变成毛玻璃白条。
    $route() {
      this.$nextTick(() => this.handleScroll());
    }
  },
  methods: {
    jumpuser(value) {
      if (value) {
        this.$router.push({
          path: '/user',
          query: {
            scroll: true
          }
        });
        return;
      } else {
        this.$router.push('/user');

      }
    },
    jumpuserinfo() {
      this.$router.push('/userinfo');
    },
    jump(path, value) {
      this.$gtag.event('click', {
        event_category: '首页跳转', // 事件类别，用于对事件进行分组
        event_label: value,       // 事件标签，用于标识被点击的按钮
        value: 1,                       // 可选，可以为按钮点击分配一个数值（如用于衡量重要性或频率）
        // 其他自定义参数
        button_text: value,          // 按钮上的文本
        page_location: window.location.pathname // 发生点击事件的页面路径
      });
      if (path == '/authorhome') {
        if (localStorage.getItem('token')) {
          this.$router.push(path);
        } else {
          this.$message({
            message: 'Please log in first',
            type: 'warning',
            duration: 1000,
            onClose: () => {
              //此处写提示关闭后需要执行的函数
              this.$router.replace({
                path: '/login',
              })
            }
          })
          return
        }
      } else {
        this.$router.push(path);

      }
    },
    jumplogin() {
      this.$router.push('/login');
    },
    jumplibrary() {
      this.$gtag.event('click', {
        event_category: '首页跳转', // 事件类别，用于对事件进行分组
        event_label: '跳转书架',       // 事件标签，用于标识被点击的按钮
        value: 1,                       // 可选，可以为按钮点击分配一个数值（如用于衡量重要性或频率）
      });
      this.$router.push('/library');
    },
    outlogin() {
      localStorage.removeItem('token');
      this.$store.dispatch('login');
      this.$message({
        message: 'Log out successfully',
        type: 'warning',
        duration: 1000,
      });
      // 一秒后刷新页面
      setTimeout(() => {
        window.location.reload();
      }, 1000)

    },
    jumppolicy(value) {
      if (value == 1) {
        this.$router.push('/termsService')
      } else if (value == 2) {
        this.$router.push('/provacyPolicy')
      } else if (value == 3) {
        // this.$router.push('/policy/3')
        this.$message.warning('No content');
      }
    },
    showContactUs() {
      this.contactUsShow = true;
    },
    closeContactUs() {
      this.contactUsShow = false;
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // 移动端：按首页 hero 实际高度判定——越过 hero（进入白色内容区）才让顶栏变毛玻璃白；
      // 桌面端：沿用原 1000px 阈值。isSticky=true 即 .indexheader 透明态。
      if (window.innerWidth <= 768) {
        const hero = document.querySelector('.dialogue');
        const threshold = hero ? Math.max(hero.offsetHeight - 54, 80) : 360;
        this.isSticky = scrollTop <= threshold;
      } else {
        this.isSticky = scrollTop <= 1000;
      }
    },
    changeLanguage(value) {
      localStorage.setItem('language', value);
    },
    startPolling() {
      // 设置轮询间隔（例如，每5秒一次）
      this.pollingInterval = setInterval(this.fetchNotifications, 10000);
    },
    stopPolling() {
      // 清除轮询定时器
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    },
    fetchNotifications() {
      // 发送请求到服务器获取消息通知
      // 假设你有一个 API 端点 `/api/notifications` 返回消息通知
      websocket().then(res => {
        // 假设服务器返回了一个包含新通知的数组
        if (res.code == 200) {
          this.$store.commit('SET_WS_MSG', res.data)
        }
      }).catch(error => {
        console.error('获取消息通知时出错:', error);
      });
    },
    startBlinking() {
      // 每隔1秒切换一次显示状态
      this.blinkInterval = setInterval(() => {
        this.showDot = !this.showDot;
      }, 500);
    },
    stopBlinking() {
      // 清除定时器
      clearInterval(this.blinkInterval);
      this.blinkInterval = null;
    },
    jumpToAppStore() {
      window.open('https://apps.apple.com/tw/app/rosettanovel/id6739957946?uo=2', '_blank');
    },
    isTabActive(path) {
      return this.$route.path === path
    },
    goTab(path) {
      if (this.$route.path === path) return
      // /library、/user 允许游客（meta.allowGuest）带访客会话进入，不再拦去登录页
      this.$router.push(path)
    }
  },
  async created() {
    // 确保访客会话就绪（main.js 已先行 ensure，此处幂等兜底），再统一拉登录态/资料。
    await ensureVisitor();
    if (!localStorage.getItem('fontsize')) {
      localStorage.setItem("fontsize", 18);
    }
    this.$store.dispatch('login');

    if (this.$store.state.isLoggedIn) {
      websocket().then(res => {
        console.log(res);

        // 假设服务器返回了一个包含新通知的数组
        if (res.code == 200) {
          this.$store.commit('SET_WS_MSG', res.data)
        }
      }).catch(error => {
        console.error('获取消息通知时出错:', error);
      });
      this.startPolling();
    }

    this.languageValue = localStorage.getItem('language') || 'en';
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // 开始闪烁
    this.startBlinking();
    // console.log(this.$gtag);
  },
  updated() {
  },
  // 组件销毁前
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    this.stopPolling();
    // 停止闪烁
    this.stopBlinking();
  },
}
</script>

<style lang="less">
#app {
  font-size: 15px;
  font-family: "";

  input[aria-hidden="true"],
  div[aria-hidden="true"] {
    display: none !important;
  }

  i,
  em {
    font-style: normal;
  }

  .header {
    background-color: white;
    width: 100%;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    justify-content: center;
    display: flex;
    z-index: 9999;
    font-family: Inter;
    transition: all 0.3s;

    .typerea {
      width: 1040px;
      margin: 0 auto;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      >div {
        display: flex;
        align-items: center;

        >img {
          width: 26px;
          height: 35px;
          margin-left: 5px;
          cursor: pointer;
        }

        .tag {
          display: flex;

          .tags {
            display: flex;
            align-items: center;
            margin-left: 53px;
            cursor: pointer;
            font-size: 15px;

            img {
              width: 18px;
              height: 18px;
              margin-right: 10px;
            }
          }

          .tags:nth-child(1) {
            margin-left: 35px;
          }

        }

        .search {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-right: 16px;
        }

        .loginbut {
          display: flex;
          width: 84px;
          height: 30px;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          color: white;
          font-size: 12px;
          background: #008CD6;
          cursor: pointer;
        }

        .tou {
          width: 34px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          cursor: pointer;

          &:hover .userpopup {
            display: block;
          }

          img {
            width: 100%;
            height: 34px;
            border-radius: 50%;
          }

          .dian {
            position: absolute;
            width: 8px;
            height: 8px;
            top: 13px;
            right: -3px;
            background-color: rgb(245, 53, 53);
            border-radius: 50%;
            animation: blink 1s infinite;
          }

          @keyframes blink {

            0%,
            100% {
              opacity: 1;
            }

            50% {
              opacity: 0;
            }
          }

          .userpopup {
            position: absolute;
            width: 262px;
            height: 350px;
            border-radius: 10px;
            border: 1px solid #D9D9D9;
            background-color: white;
            top: 55px;
            right: -4px;
            display: none;
            box-sizing: border-box;
            padding: 31px 30px 27px 30px;
            z-index: 99;

            .jiao {
              position: absolute;
              border: 7px solid transparent;
              border-bottom-color: #888;
              border-radius: 2px;
              top: -14px;
              right: 10px;
            }

            .usermess {
              width: 100%;
              height: 48px;
              font-family: "PingFang SC";
              display: flex;

              img {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                margin-right: 14px;
              }

              div {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 138px;

                span {
                  font-size: 16px;
                  text-decoration: underline;
                  /* 1.让文本在一行展示 */
                  white-space: nowrap;
                  /* 2.设置溢出隐藏 */
                  overflow: hidden;
                  /* 3.超出文字变为省略号 */
                  text-overflow: ellipsis;
                }

                i {
                  font-size: 14px;
                  /* 1.让文本在一行展示 */
                  white-space: nowrap;
                  /* 2.设置溢出隐藏 */
                  overflow: hidden;
                  /* 3.超出文字变为省略号 */
                  text-overflow: ellipsis;
                }
              }
            }

            .getmore {
              height: 28px;
              width: 100%;
              display: flex;
              margin: 27px 0;
              justify-content: space-between;

              .money {
                display: flex;
                align-items: center;
                font-size: 16px;

                .r {
                  display: flex;
                  width: 28px;
                  height: 28px;
                  justify-content: center;
                  align-items: center;
                  border-radius: 50%;
                  border: 0.737px solid #FFF000;
                  background: url("./images/logo.png") #E64716 50% / cover no-repeat;
                  background-size: 14px 17.5px;
                  margin-right: 17px
                }
              }

              .button {
                display: flex;
                width: 96px;
                height: 26px;
                justify-content: center;
                align-items: center;
                border-radius: 6px;
                background: linear-gradient(96deg, #2E5AF7 4.43%, #1A8DC4 52.67%, #09C984 99.96%);
                font-size: 12px;
                color: white;
              }
            }

            .link {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              width: 120px;
              height: 94px;

              p {
                width: 100%;
                height: 18px;
                font-size: 14px;
                line-height: 18px;
                margin: 0;
                position: relative;

                em {
                  position: absolute;
                  top: -6px;
                  left: 80px;
                  font-size: 10px;
                  color: #E64716;
                }
              }
            }

            .outlogin {
              display: flex;
              width: 96px;
              height: 26px;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              background-color: #6F8CC7;
              font-size: 12px;
              color: white;
              position: absolute;
              bottom: 27px;
              right: 30px;
            }
          }
        }
      }
    }
  }

  .indexheader {
    background-color: transparent;
    border: none;
    position: relative
  }

  .bottom {
    width: 100%;
    height: 190px;
    background-color: #F5F6FB;
    padding-top: 36px;
    display: flex;
    flex-direction: column;

    .tit {
      width: 1080px;
      height: 45px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: end;

      img {
        width: 236px;
        height: 100%;
      }

      .tag {
        width: 700px;
        height: 28px;
        display: flex;
        justify-content: space-between;
        font-family: "PingFang SC";
        font-size: 15px;
        font-style: normal;
        color: #333;
        font-weight: 400;

        span {
          cursor: pointer;
          transition: color 0.3s ease;

          &:hover {
            color: #6F8CC7;
          }
        }
      }
    }

    .con {
      width: 1080px;
      margin: 0 auto;
      display: flex;
      margin-top: 30px;

      .apple {
        box-sizing: border-box;
        width: 148px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        margin-right: 18px;
        padding: 4.5px 14px 4.5px 8px;
        background-image: url(./images/apple-bg.png);
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.05);
          opacity: 0.9;
        }

        img {
          width: 35px;
          height: 35px;
        }

        .store {
          color: white;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          span {
            font-family: "PingFang SC";
            font-size: 9.62px;
            font-weight: 300;
          }

          i {
            font-family: "PingFang SC";
            font-size: 17.76px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }

      img {
        width: 148px;
        height: 44px;
      }
    }

    .bot {
      margin-top: 36px;
      border-top: 1px solid #CCC;
      flex: 1;

      .typerea {
        width: 1080px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        color: #646464;

        i {
          cursor: pointer;

          &:hover {
            text-decoration: underline;
            color: #333
          }
        }
      }
    }
  }

  // Contact Us Modal Styles
  .contact-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .contact-modal {
    background: white;
    border-radius: 12px;
    width: 500px;
    max-width: 90vw;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  }

  .contact-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #eee;

    h3 {
      margin: 0;
      font-family: "PingFang SC";
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }

    .close-btn {
      font-size: 24px;
      color: #999;
      cursor: pointer;
      line-height: 1;

      &:hover {
        color: #333;
      }
    }
  }

  .contact-modal-content {
    padding: 24px;

    .contact-section {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      h4 {
        margin: 0 0 12px 0;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }

      p {
        margin: 8px 0;
        font-family: "PingFang SC";
        font-size: 14px;
        color: #666;
        line-height: 1.5;

        strong {
          color: #333;
        }

        a {
          color: #6F8CC7;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

/* ===================== 移动端适配（读者端外壳） ===================== */
/* 桌面端默认隐藏底部 Tab 栏 */
.mobile-tabbar { display: none; }

@media (max-width: 768px) {
  #app {
    font-size: 14px;
    /* iOS 风：SF 系统字体 + 抗锯齿 */
    font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #1c1c1e;

    /* ===== 统一移动端设计 token：所有读者页一律引用，保证整体风格一致 ===== */
    --m-bg: #f2f2f7;          /* 分组页底色 */
    --m-card: #ffffff;        /* 卡片 */
    --m-text: #1c1c1e;        /* 主文字 */
    --m-text2: #8e8e93;       /* 次文字 */
    --m-accent: #e64716;      /* 品牌主色（按钮/选中/强调） */
    --m-accent-soft: rgba(230, 71, 22, 0.12); /* 主色浅底 */
    --m-blue: #1757a6;        /* 次级蓝（频道/链接） */
    --m-line: rgba(60, 60, 67, 0.12);  /* 0.5px 分隔/描边 */
    --m-radius: 14px;         /* 卡片圆角 */
    --m-radius-sm: 10px;
    --m-radius-btn: 12px;
    --m-pad: 16px;            /* 页面左右内边距 */
    --m-gap: 12px;            /* 卡片/元素间距 */
    --m-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* 卡片阴影 */

    /* 标题字体兜底：原设计用的「Alibaba PuHuiTi 3.0」未内嵌，非苹果设备会回退成丑陋衬线，
       这里把主要标题类统一重映射到 SF 系统字体（仅作用于文字容器，不影响 iconfont/el-icon）。 */
    .readuser :is(h1, h2, h3, h4, h5, .tit, .title, .welcome, .ranktit, .name, .bookname),
    .readuser :is(.tit, .title) :is(div, span, p) {
      font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "PingFang SC", "Segoe UI", Roboto, sans-serif !important;
    }

    /* iOS 导航栏：毛玻璃材质 + 0.5px 分隔线；背景/模糊做平滑过渡，下滑进入白色区时柔和淡入 */
    .header {
      position: sticky;
      top: 0;
      background: rgba(255, 255, 255, 0.72);
      -webkit-backdrop-filter: saturate(180%) blur(20px);
      backdrop-filter: saturate(180%) blur(20px);
      border-bottom: 0.5px solid rgba(60, 60, 67, 0.18);
      transition: background 0.3s ease, -webkit-backdrop-filter 0.3s ease, backdrop-filter 0.3s ease, border-color 0.3s ease;
    }

    /* 首页 hero 上：sticky 常驻 + 透明（不显白底），下滑越过 hero 后自动变回上面的毛玻璃白 */
    .indexheader {
      position: sticky;
      top: 0;
      background: transparent;
      -webkit-backdrop-filter: none;
      backdrop-filter: none;
      border-bottom: none;

      /* 首页顶部沉浸式：隐藏顶栏里多余的搜索框（hero 已有 AI 搜索），
         只留 logo + Sign in 浮在渐变上；下滑 >1000px 后顶栏变回毛玻璃、搜索框自然恢复 */
      .search {
        display: none !important;
      }
    }

    /* 全局兜底：所有读者页不允许横向超宽。
       用 overflow-x: clip 而非 hidden —— clip 不创建滚动容器，不破坏 sticky 顶栏；
       fixed 的底部 Tab 栏因 .readuser 无 transform 也不会被裁。内部横滑区有各自 overflow，不受影响。 */
    .readuser {
      overflow-x: clip;
    }

    /* 顶栏：去掉定宽，压缩高度，隐藏桌面导航（已移到底部 Tab） */
    .header .typerea {
      width: 100%;
      box-sizing: border-box;
      padding: 0 12px;
      height: 48px;

      >div {
        >img {
          margin-left: 0;
        }

        .tag {
          display: none;
        }

        /* 头像下拉气泡：贴右、防溢出 */
        .tou .userpopup {
          right: 0;
          width: 240px;
        }
      }

      /* 右侧组（搜索 + 头像）撑满，搜索条铺满中间 */
      >div:nth-child(2) {
        flex: 1 1 auto;
        min-width: 0;
        margin-left: 12px;

        .search {
          flex: 1 1 auto;
          min-width: 0;
          margin-right: 10px;
          justify-content: stretch;
        }

        /* Sign in / 头像始终靠右（hero 上搜索框隐藏时也不左漂） */
        .loginbut,
        .tou {
          margin-left: auto;
        }
      }
    }

    /* 底栏：纵向堆叠、流式宽度 */
    .bottom {
      height: auto;
      box-sizing: border-box;
      padding: 24px 16px 16px;

      .tit {
        width: 100%;
        height: auto;
        flex-direction: column;
        align-items: flex-start;
        gap: 14px;

        img {
          width: 160px;
          height: auto;
        }

        .tag {
          width: 100%;
          height: auto;
          flex-wrap: wrap;
          gap: 12px 22px;
        }
      }

      .con {
        width: 100%;
        margin-top: 20px;
      }

      .bot {
        margin-top: 20px;

        .typerea {
          width: 100%;
          height: auto;
          flex-direction: column;
          align-items: flex-start;
          gap: 6px;
          padding: 12px 0;
        }
      }
    }

    /* 有底部 Tab 的页面，给内容留出底部安全区 */
    .readuser.has-tabbar {
      padding-bottom: calc(50px + env(safe-area-inset-bottom));
    }
  }

  /* iOS 底部 Tab 栏：毛玻璃材质 + 品牌 tint */
  .mobile-tabbar {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: calc(50px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
    background: rgba(255, 255, 255, 0.82);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    backdrop-filter: saturate(180%) blur(20px);
    border-top: 0.5px solid rgba(60, 60, 67, 0.18);
    z-index: 10000;

    .tab-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 3px;
      color: #8e8e93;
      cursor: pointer;
      text-decoration: none;
      -webkit-tap-highlight-color: transparent;
      transition: color 0.15s ease;

      .tab-ico {
        display: flex;

        svg {
          width: 25px;
          height: 25px;
          display: block;
          stroke-width: 1.8;
        }
      }

      .tab-label {
        font-size: 10px;
        line-height: 1;
        font-weight: 500;
        letter-spacing: 0.2px;
      }

      &:active {
        opacity: 0.5;
      }

      &.active {
        color: #E64716;
      }
    }
  }
}

/* Element toast 挂在 body 下（不在 #app 内），单独一段。
   every.css 把 .el-message 定成 left:80% !important（桌面右上角风格），
   窄屏上会半出屏 —— 移动端改回水平居中、宽度跟随视口、定高放开防裁字 */
@media (max-width: 768px) {

  /* body 前缀提权：every.css 里同为 !important，靠权重压过它 */
  body .el-message {
    min-width: 0 !important;
    max-width: calc(100vw - 24px);
    left: 50% !important;
    height: auto !important;
    min-height: 46px;
  }
}
</style>
